function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import _ from 'underscore';
import Jstree from 'jstree';
import { Databases } from './databases';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var _default = /*#__PURE__*/function (_Databases) {
  function _default(props) {
    var _this2;
    _classCallCheck(this, _default);
    _this2 = _callSuper(this, _default, [props]);
    _this2.handleLoadTree = _this2.handleLoadTree.bind(_this2);
    _this2.renderDatabases = _this2.renderDatabases.bind(_this2);
    _this2.renderDatabaseSearch = _this2.renderDatabaseSearch.bind(_this2);
    _this2.renderDatabaseTree = _this2.renderDatabaseTree.bind(_this2);
    return _this2;
  }
  _inherits(_default, _Databases);
  return _createClass(_default, [{
    key: "handleLoadTree",
    value: function handleLoadTree(category) {
      var tree_id = '#' + category + '_database_tree';
      // hack that is needed to sync the selected tree db with the hidden main db
      window.jstree_node_change_timeout = null;
      window.jstree_rapid_timeout = null;
      var _this = this;
      $(tree_id).on('select_node.jstree deselect_node.jstree', function (_, _data) {
        if (window.jstree_node_change_timeout) clearTimeout(window.jstree_node_change_timeout);
        if (window.jstree_rapid_timeout) clearTimeout(window.jstree_rapid_timeout);

        // Set a timeout to handle jsTree node changes with some delay to avoid rapid re-triggering
        window.jstree_rapid_timeout = setTimeout(function () {
          // Set another timeout to handle the retrieval and processing of selected nodes
          window.jstree_node_change_timeout = setTimeout(function () {
            // Filter out the current category to get a list of other categories
            var otherCategories = _this.categories().filter(function (item) {
              return item !== category;
            });

            // Uncheck all nodes in the trees of the other categories
            otherCategories.forEach(function (value) {
              return $("#".concat(value, "_database_tree")).jstree('uncheck_all');
            });
            // Get all selected nodes from the current tree.
            // Note: This will also include folders. To filter only database nodes, ensure the ID length is 32.
            // These IDs correspond to specific elements in the hidden main form.
            var selected = $(tree_id).jstree('get_selected').filter(function (selected) {
              return selected.length === 32;
            });

            // Find database entries in the current category whose IDs match the selected nodes
            var foundDatabases = _this.databases(category).filter(function (db) {
              return selected.includes(db.id);
            });

            // Update the selected databases in the view model with the found databases
            _this.selectDatabases(foundDatabases);
          }, 100); // Delay to ensure jsTree updates are processed
        }, 100); // Delay to prevent rapid changes causing multiple triggers
      });
      $(tree_id).jstree({
        'core': {
          'data': this.props.tree[category]
        },
        'plugins': ['checkbox', 'search', 'sort'],
        'checkbox': {
          'keep_selected_style': false
        }
      });
    }
  }, {
    key: "selectDatabases",
    value: function selectDatabases(databases) {
      this.setState({
        currentlySelectedDatabases: databases
      });
    }
  }, {
    key: "handleTreeSearch",
    value: function handleTreeSearch(category, tree_id, search_id) {
      var search_for = $('#' + search_id).val();
      $('#' + tree_id).jstree(true).search(search_for);
    }
  }, {
    key: "renderDatabases",
    value: function renderDatabases(category) {
      // Panel name and column width.
      var panelTitle = category[0].toUpperCase() + category.substring(1).toLowerCase() + ' databases';
      var columnClass = this.categories().length === 1 ? 'col-span-2' : '';

      // Toggle button.
      var toggleState = '[Select all]';
      var toggleClass = 'px-2 text-base md:text-lg hidden';
      var toggleShown = this.databases(category).length > 1;
      var toggleDisabled = this.state.type && this.state.type !== category;
      if (toggleShown && toggleDisabled) {
        toggleClass += ' text-gray-400';
      } else {
        toggleClass += ' text-seqblue';
      }
      if (!toggleShown) toggleClass += ' hidden';
      if (this.nselected() === this.databases(category).length) {
        toggleState = '[Deselect all]';
      }

      // JSX.
      return /*#__PURE__*/_jsxs("div", {
        className: columnClass,
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "border-b border-seqorange mb-2",
            id: "database_list",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "font-medium text-base md:text-lg",
              children: panelTitle
            }), this.renderDatabaseSearch(category), /*#__PURE__*/_jsx("button", {
              type: "button",
              className: toggleClass,
              disabled: toggleDisabled,
              onClick: function () {
                this.handleToggle(toggleState, category);
              }.bind(this),
              children: toggleState
            })]
          }), /*#__PURE__*/_jsx("ul", {
            className: 'databases hidden text-lg ' + category,
            children: _.map(this.databases(category), _.bind(function (database, index) {
              return /*#__PURE__*/_jsx("li", {
                children: this.renderDatabase(database)
              }, 'DB_' + category + index);
            }, this))
          })]
        }), this.renderDatabaseTree(category), /*#__PURE__*/_jsx("link", {
          rel: "stylesheet",
          media: "screen,print",
          type: "text/css",
          href: "vendor/github/vakata/jstree@3.3.8/dist/themes/default/style.min.css"
        })]
      }, 'DB_' + category);
    }
  }, {
    key: "renderDatabaseSearch",
    value: function renderDatabaseSearch(category) {
      var tree_id = category + '_database_tree';
      var search_id = tree_id + '_search';
      return /*#__PURE__*/_jsx("input", {
        type: "text",
        id: search_id,
        className: "border rounded px-1",
        placeholder: "Search...",
        onKeyUp: _.bind(function () {
          this.handleTreeSearch(category, tree_id, search_id);
        }, this)
      });
    }
  }, {
    key: "renderDatabaseTree",
    value: function renderDatabaseTree(category) {
      var tree_id = category + '_database_tree';
      var data = this.props.tree[category];
      return /*#__PURE__*/_jsx("div", {
        id: tree_id,
        className: 'jstree_div',
        onClick: _.bind(function () {
          this.handleLoadTree(category);
        }, this)
      });
    }
  }]);
}(Databases);
export { _default as default };